import { z } from "zod";

export default z
  .object({
    tag: z.union([z.literal("hybridId"), z.literal("email_sha256")]),
    priority: z.number().default(10).optional(),
    id: z.string(),
  })
  .strict();
